import { NewsCardComponentsModule } from 'src/app/components/news-card/news-card.components.module';
import { AccountComponentsModule } from 'src/app/components/account/account.components.module';
import { SelectAllComponentsModule } from 'src/app/components/general/select-all/select-all.components.module';
import { SearchComponentsModule } from 'src/app/components/general/search/search.components.module';
import { AccountsFilterComponent } from 'src/app/components/accounts/accounts-filter/accounts-filter.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { OfflineComponentsModule } from 'src/app/components/general/offline/offline.components.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
// import { ScrollingModule as ExperimentalScrollingModule } from '@angular/cdk-experimental/scrolling';

import { IonicModule } from '@ionic/angular';

import { AccountsListPageRoutingModule } from './accounts-list-routing.module';

import { AccountsListPage } from './accounts-list.page';
import { InboxComponentsModule } from 'src/app/components/inbox/inbox.components.module';
import { CachedImageComponentsModule } from 'src/app/components/general/cached-image/cached-image.components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    OfflineComponentsModule,
    InboxComponentsModule,
    IonicModule,
    SearchComponentsModule,
    SelectAllComponentsModule,
    AccountComponentsModule,
    NewsCardComponentsModule,
    AccountsListPageRoutingModule,
    ScrollingModule,
    CachedImageComponentsModule,
    // ExperimentalScrollingModule,
  ],
  declarations: [
    AccountsListPage,
    AccountsFilterComponent
  ],
  // entryComponents: [
  //   AccountsFilterComponent
  // ]
})
export class AccountsListPageModule {}
